module.exports = __webpack_public_path__ + "static/media/uzakrota-logo-dark.d0d1c73c.png";